'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = errorListener;

var _actions = require('../../store/actions');

var _store = require('../../store');

function errorListener(state, next, playerId) {
  (0, _store.storeInstance)().dispatch((0, _actions.setErrorInternal)(playerId, (0, _store.getPlayerInstance)(playerId).error));
}
module.exports = exports['default'];